export default class Wire {
    constructor(a, b, type) {
        this.a = a;
        this.b = b;
        this.type = type;
        this.a.connectTo(b, this);
    }
    isConnecting(a, b) {
        return (this.a === a && this.b === b) || (this.a === b && this.b === a);
    }
}
Wire.WIDTH = 5;
